module.exports = __webpack_public_path__ + "static/media/Icon-info.9e5eac56.svg";